export default __webpack_public_path__ + "static/media/heinikenKlein.39277e29.jpg";